module.exports = __webpack_public_path__ + "assets/img/jianjiangkeji1.5c936c30.png";